(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nk-about-founder"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nkxVideo) return;
  window.__nkxVideo = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-nkx-play]') : null;
    if (!btn) return;
    var box = btn.closest('[data-nkx-video]');
    var tpl = box && box.querySelector('template');
    if (!tpl) return;
    var player = document.createElement('div');
    player.className = 'nkx-player';
    player.appendChild(tpl.content.cloneNode(true));
    box.appendChild(player);
    btn.hidden = true;
    var video = player.querySelector('video');
    if (video && video.play) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nk-about-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__nkxVideo) return;
  window.__nkxVideo = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-nkx-play]') : null;
    if (!btn) return;
    var box = btn.closest('[data-nkx-video]');
    var tpl = box && box.querySelector('template');
    if (!tpl) return;
    var player = document.createElement('div');
    player.className = 'nkx-player';
    player.appendChild(tpl.content.cloneNode(true));
    box.appendChild(player);
    btn.hidden = true;
    var video = player.querySelector('video');
    if (video && video.play) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nk-about-promise"] && !Shopify.designMode) return;
  try {
    
(function () {
  function start(el) {
    if (el.dataset.nkaReady) return;
    el.dataset.nkaReady = '1';
    var words;
    try { words = JSON.parse(el.getAttribute('data-nka-words')); } catch (e) { return; }
    if (!words || words.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () {
      el.classList.add('is-out');
      setTimeout(function () {
        i = (i + 1) % words.length;
        el.textContent = String(words[i]).trim();
        el.classList.remove('is-out');
      }, 350);
    }, 2600);
  }
  function boot() { document.querySelectorAll('[data-nka-words]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nk-product-ingredients"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.nkiReady) return;
    root.dataset.nkiReady = '1';
    var items = root.querySelectorAll('[data-nki-item]');
    var bgs = root.querySelectorAll('[data-nki-bg]');
    var list = root.querySelector('.nki-list');
    if (list) list.style.setProperty('--nki-cols', String(Math.min(items.length, 4) || 1));

    function showBg(key) {
      var target = root.querySelector('[data-nki-bg="' + key + '"]') || root.querySelector('[data-nki-bg="default"]');
      if (!target) return;
      bgs.forEach(function (b) {
        var on = b === target;
        b.classList.toggle('is-active', on);
      });
    }

    items.forEach(function (it) {
      it.addEventListener('click', function () {
        items.forEach(function (o) {
          var on = o === it;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        showBg(it.getAttribute('data-nki-item'));
      });
    });

    // First card active → its background
    var first = root.querySelector('.nki-item.is-active') || items[0];
    if (first) showBg(first.getAttribute('data-nki-item'));
  }
  function boot() { document.querySelectorAll('[data-nki]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nk-product-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(cents) {
    var n = Math.round(Number(cents) / 100);
    if (!isFinite(n)) n = 0;
    return '₹' + String(n);
  }

  function init(root) {
    if (!root || root.dataset.nkpReady) return;
    root.dataset.nkpReady = '1';
    var product, fmt;
    try { product = JSON.parse(root.querySelector('[data-nkp-json]').textContent); fmt = JSON.parse(root.querySelector('[data-nkp-money]').textContent); } catch (e) { return; }

    // gallery
    function show(id) {
      if (!id) return;
      var slide = root.querySelector('[data-nkp-slide="' + id + '"]');
      if (!slide) return;
      root.querySelectorAll('[data-nkp-slide]').forEach(function (s) {
        var on = s === slide;
        s.classList.toggle('is-active', on);
        if (!on) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
      root.querySelectorAll('[data-nkp-thumb]').forEach(function (t) {
        var on = t.getAttribute('data-nkp-thumb') === String(id);
        t.classList.toggle('is-active', on);
        if (on && t.scrollIntoView && window.matchMedia('(min-width: 990px)').matches) {
          var list = t.parentNode; list.scrollTo({ top: t.offsetTop - 0, behavior: 'smooth' });
        }
      });
    }
    root.querySelectorAll('[data-nkp-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { show(t.getAttribute('data-nkp-thumb')); });
    });
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-nkp-slide]'));
    function step(dir) {
      if (!slides.length) return;
      var i = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      if (i < 0) i = 0;
      var next = slides[(i + dir + slides.length) % slides.length];
      if (next) show(next.getAttribute('data-nkp-slide'));
    }
    var prevBtn = root.querySelector('[data-nkp-prev]'), nextBtn = root.querySelector('[data-nkp-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    var thumbs = root.querySelector('[data-nkp-thumbs]'), more = root.querySelector('[data-nkp-more]');
    if (thumbs && more) {
      more.addEventListener('click', function () { thumbs.scrollBy({ top: 172, behavior: 'smooth' }); });
      var endCheck = function () { more.classList.toggle('is-end', thumbs.scrollTop + thumbs.clientHeight >= thumbs.scrollHeight - 4); };
      thumbs.addEventListener('scroll', endCheck, { passive: true });
      endCheck();
    }

    // variants / size pills
    var idInput = root.querySelector('[data-nkp-id]'), atc = root.querySelector('[data-nkp-atc]');
    var buyNow = root.querySelector('[data-nkp-buy-now]');
    var sizeProp = root.querySelector('[data-nkp-size-prop]');
    var fallbackSizes = !!root.querySelector('[data-nkp-fallback-sizes]');
    var onlyDefault = !product.variants || product.variants.length < 2 || (product.variants.length === 1 && (!product.variants[0].public_title || product.variants[0].title === 'Default Title'));
    if (fallbackSizes && onlyDefault && product.variants && product.variants[0]) {
      var base = product.variants[0];
      var fake = [];
      root.querySelectorAll('[data-nkp-fallback-sizes] [data-nkp-opt]').forEach(function (input) {
        var cents = parseInt(input.getAttribute('data-nkp-price'), 10);
        if (!cents) return;
        fake.push({ id: base.id, title: input.value, option1: input.value, options: [input.value], available: base.available !== false, price: cents, compare_at_price: null, featured_media: base.featured_media || null, name: (product.title || '') + ' - ' + input.value });
      });
      if (fake.length) product.variants = fake;
    }
    function current() {
      var picked = [];
      root.querySelectorAll('[data-nkp-opt]:checked').forEach(function (i) { picked[+i.getAttribute('data-nkp-opt')] = i.value; });
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return picked[i] === undefined || picked[i] === o; }); });
    }
    function pctOff(price, compare) {
      if (!compare || compare <= price) return '';
      var p = Math.round((compare - price) * 10000 / compare) / 100;
      return (p % 1 === 0 ? String(p) : p.toFixed(2)) + '% OFF';
    }
    function setPriceUI(price, compare) {
      var hasOff = compare && compare > price;
      root.querySelectorAll('[data-nkp-price]').forEach(function (box) {
        var n = box.querySelector('[data-nkp-now]');
        var w = box.querySelector('[data-nkp-was]');
        var o = box.querySelector('[data-nkp-off]');
        if (n) n.textContent = money(price);
        if (w) { w.hidden = !hasOff; if (hasOff) w.textContent = money(compare); }
        if (o) { o.hidden = !hasOff; if (hasOff) o.textContent = pctOff(price, compare); }
      });
    }
    function update() {
      var selected = root.querySelector('[data-nkp-opt]:checked');
      if (sizeProp && selected) sizeProp.value = selected.value;
      var v = current();
      if (fallbackSizes && selected && selected.getAttribute('data-nkp-price')) {
        var price = parseInt(selected.getAttribute('data-nkp-price'), 10) || 0;
        var compare = parseInt(selected.getAttribute('data-nkp-compare'), 10) || 0;
        setPriceUI(price, compare);
        if (v) {
          idInput.value = v.id;
          atc.disabled = !v.available;
          atc.textContent = v.available ? atc.getAttribute('data-label') : 'Sold out';
          if (buyNow) buyNow.disabled = !v.available;
        }
        return;
      }
      if (!v) { atc.disabled = true; atc.textContent = 'Unavailable'; if (buyNow) buyNow.disabled = true; return; }
      idInput.value = v.id;
      setPriceUI(v.price, v.compare_at_price);
      atc.disabled = !v.available;
      atc.textContent = v.available ? atc.getAttribute('data-label') : 'Sold out';
      if (buyNow) buyNow.disabled = !v.available;
      if (v.featured_media) show(v.featured_media.id);
      if (!fallbackSizes && window.history && history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
      }
    }
    var volumeLabel = root.querySelector('[data-nkp-volume-label]');
    function syncVolumeLabel() {
      var selected = root.querySelector('[data-nkp-opt]:checked');
      if (volumeLabel && selected) volumeLabel.textContent = selected.value;
    }
    root.querySelectorAll('[data-nkp-opt]').forEach(function (i) {
      i.addEventListener('change', function () { update(); syncVolumeLabel(); });
    });
    if (fallbackSizes) update();
    syncVolumeLabel();

    var versionLabel = root.querySelector('[data-nkp-version-label]');
    root.querySelectorAll('[data-nkp-version-opt]').forEach(function (i) {
      i.addEventListener('change', function () {
        if (versionLabel && i.checked) versionLabel.textContent = i.value;
      });
    });

    // quantity
    var qty = root.querySelector('[data-nkp-qty]');
    root.querySelectorAll('[data-nkp-step]').forEach(function (b) {
      b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-nkp-step'), 10)); });
    });

    // add to cart → right cart drawer (desktop + mobile); falls back to form post without JS
    var form = root.querySelector('[data-nkp-form]'), msg = root.querySelector('[data-nkp-msg]');
    function setBuyBusy(on) {
      if (!buyNow) return;
      buyNow.disabled = !!on || (current() && !current().available);
    }
    function doAdd(thenCheckout) {
      if (typeof window.nkAddToCart !== 'function') {
        if (thenCheckout) {
          var ret = form.querySelector('[name="return_to"]');
          if (!ret) { ret = document.createElement('input'); ret.type = 'hidden'; ret.name = 'return_to'; form.appendChild(ret); }
          ret.value = '/checkout';
        }
        form.submit();
        return;
      }
      var label = atc.getAttribute('data-label') || 'Add to Cart';
      atc.disabled = true;
      atc.setAttribute('aria-busy', 'true');
      atc.textContent = thenCheckout ? 'Buying…' : 'Adding…';
      setBuyBusy(true);
      msg.hidden = true;
      window.nkAddToCart(form).then(function () {
        if (thenCheckout) { window.location.href = '/checkout'; return; }
        atc.textContent = 'Added ✓';
        atc.classList.add('is-added');
        setTimeout(function () {
          atc.textContent = label;
          atc.classList.remove('is-added');
        }, 1600);
      }).catch(function (err) {
        msg.textContent = err.message || 'Could not add to cart';
        msg.hidden = false;
        atc.textContent = label;
      }).then(function () {
        if (thenCheckout) return;
        atc.removeAttribute('aria-busy');
        atc.disabled = false;
        setBuyBusy(false);
        var v = current();
        if (v && !v.available) { atc.disabled = true; setBuyBusy(true); }
      });
    }
    if (form && window.fetch && root.getAttribute('data-after-add') !== 'cart') {
      form.addEventListener('submit', function (e) {
        if (typeof window.nkAddToCart !== 'function') return;
        e.preventDefault();
        if (atc.getAttribute('aria-busy') === 'true') return;
        doAdd(false);
      });
    }
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        if (buyNow.disabled || atc.getAttribute('aria-busy') === 'true') return;
        doAdd(true);
      });
    }

    // mobile upsell carousel + ADD (live variant price already in liquid)
    var upsell = root.querySelector('[data-nkp-upsell]');
    if (upsell) {
      var track = upsell.querySelector('[data-nkp-upsell-track]');
      var cards = upsell.querySelectorAll('[data-nkp-upsell-card]');
      var uIdx = 0;
      function goUpsell(i) {
        if (!cards.length) return;
        uIdx = (i + cards.length) % cards.length;
        track.style.transform = 'translateX(-' + (uIdx * 100) + '%)';
      }
      var uPrev = upsell.querySelector('[data-nkp-upsell-prev]');
      var uNext = upsell.querySelector('[data-nkp-upsell-next]');
      if (uPrev) uPrev.addEventListener('click', function () { goUpsell(uIdx - 1); });
      if (uNext) uNext.addEventListener('click', function () { goUpsell(uIdx + 1); });
      if (cards.length < 2) {
        if (uPrev) uPrev.hidden = true;
        if (uNext) uNext.hidden = true;
      }
      upsell.querySelectorAll('[data-nkp-upsell-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-nkp-upsell-add');
          if (!id || btn.disabled) return;
          var label = 'ADD';
          btn.disabled = true;
          btn.textContent = '…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          }).then(function (r) {
            if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add'); });
            return r.json();
          }).then(function () {
            btn.textContent = 'ADDED';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if (typeof window.nkOpenCartDrawer === 'function') window.nkOpenCartDrawer();
            setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1400);
          }).catch(function () {
            btn.textContent = label;
            btn.disabled = false;
          });
        });
      });
    }

    // wishlist (saved in this browser)
    var wish = root.querySelector('[data-nkp-wish]');
    if (wish) {
      var key = 'nk-wishlist', handle = wish.getAttribute('data-nkp-wish');
      var read = function () { try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; } };
      wish.setAttribute('aria-pressed', read().indexOf(handle) > -1 ? 'true' : 'false');
      wish.addEventListener('click', function () {
        var list = read(), i = list.indexOf(handle);
        if (i > -1) list.splice(i, 1); else list.push(handle);
        try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
        wish.setAttribute('aria-pressed', i > -1 ? 'false' : 'true');
      });
    }

  }
  function boot() { document.querySelectorAll('[data-nkp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nk-product-routine"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.nkrReady) return;
    root.dataset.nkrReady = '1';
    var sw = root.querySelector('[data-nkr-switch]');
    if (!sw) return;
    function set(right) {
      sw.setAttribute('aria-checked', right ? 'true' : 'false');
      root.querySelectorAll('[data-nkr-panel]').forEach(function (p) { p.hidden = (p.getAttribute('data-nkr-panel') === 'right') !== right; });
    }
    sw.addEventListener('click', function () { set(sw.getAttribute('aria-checked') !== 'true'); });
    var labels = root.querySelectorAll('.nkx-switch__label');
    if (labels[0]) labels[0].addEventListener('click', function () { set(false); });
    if (labels[1]) labels[1].addEventListener('click', function () { set(true); });
  }
  function boot() { document.querySelectorAll('[data-nkr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nk-product-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.nkvReady) return;
    root.dataset.nkvReady = '1';
    var dlg = root.querySelector('[data-nkv-dialog]'), body = root.querySelector('[data-nkv-body]');
    if (!dlg || !body) return;
    function close() { body.querySelectorAll('video').forEach(function (v) { v.pause(); }); body.innerHTML = ''; if (dlg.open) dlg.close(); }
    root.querySelectorAll('[data-nkv-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tpl = btn.parentNode.querySelector('template');
        if (!tpl) return;
        body.innerHTML = '';
        body.appendChild(tpl.content.cloneNode(true));
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        var v = body.querySelector('video'); if (v && v.play) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        var form = body.querySelector('[data-nkv-form]');
        if (form && window.fetch && typeof window.nkAddToCart === 'function') {
          form.addEventListener('submit', function (e) {
            e.preventDefault();
            var b = form.querySelector('button'), m = form.querySelector('.nkv-msg'), label = b.textContent;
            if (b.getAttribute('aria-busy') === 'true') return;
            b.disabled = true; b.setAttribute('aria-busy', 'true'); b.textContent = 'Adding…'; m.hidden = true;
            window.nkAddToCart(form).then(function () {
              b.textContent = 'Added ✓';
              setTimeout(function () { b.textContent = label; }, 1600);
            }).catch(function (err) {
              m.textContent = err.message; m.hidden = false; b.textContent = label;
            }).then(function () { b.removeAttribute('aria-busy'); b.disabled = false; });
          });
        }
      });
    });
    root.querySelector('[data-nkv-close]').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('close', function () { body.innerHTML = ''; });
  }
  function boot() { document.querySelectorAll('[data-nkv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nk-shop-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.nksReady) return;
    root.dataset.nksReady = '1';

    var sort = root.querySelector('[data-nks-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        window.location.href = url.toString();
      });
    }

    var form = root.querySelector('[data-nks-filters]');
    if (form) {
      form.querySelectorAll('[data-nks-filter-input]').forEach(function (input) {
        input.addEventListener('change', function () {
          var url = new URL(window.location.href);
          // rebuild from checked boxes
          form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
            url.searchParams.delete(cb.name);
          });
          var groups = {};
          form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
            if (!groups[cb.name]) groups[cb.name] = [];
            groups[cb.name].push(cb.value);
          });
          Object.keys(groups).forEach(function (name) {
            groups[name].forEach(function (val) { url.searchParams.append(name, val); });
          });
          form.querySelectorAll('input[type="number"]').forEach(function (n) {
            if (n.value) url.searchParams.set(n.name, n.value);
            else url.searchParams.delete(n.name);
          });
          window.location.href = url.toString();
        });
      });
    }

    root.querySelectorAll('[data-nks-atc-form]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        if (typeof window.nkAddToCart !== 'function') return;
        e.preventDefault();
        var btn = f.querySelector('[type="submit"]');
        var label = btn ? btn.textContent : 'Add to Cart';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
        window.nkAddToCart(f).then(function () {
          if (btn) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1200); }
        }).catch(function () {
          if (btn) { btn.textContent = label; btn.disabled = false; }
        });
      });
    });
  }
  function boot() { document.querySelectorAll('[data-nks]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
